// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Fields.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Fields component
 */

import React from 'react';
import FieldDetail from 'modules/ReportDesigner/Fields/Izenda.FieldDetail';
import FieldTreeContainer from './Izenda.FieldTreeContainer';
import DnDFieldsConfig from './Izenda.DnDFieldsConfig';
import Constants from 'logic/data/Izenda.ReportDesignerConstants';

export default {
  setStore: function(store: any): void {
    this.store = store.fieldsStore;
    this.isReloadView = false;
  },

  destroy: function(): void {
    delete this['store'];
    this.isReloadView = false;
  },

  reloadView: function(): any {
    this.isReloadView = true;
    return this.store.loadInitial();
  },

  renderMiddlePanel: function(): any {
    return <FieldTreeContainer store={this.store} uiStore={DnDFieldsConfig.sourceOptions} />;
  },

  renderMainContent: function(ref: any, updateResultInfo: any): any {
    return (
      <FieldDetail
        ref={ref}
        updateResultInfo={updateResultInfo}
        store={this.store}
        uiStore={DnDFieldsConfig.targetOptions}
        isReloadView={this.isReloadView}
        pageName={Constants.PAGE_NAME.FIELDS}
      />
    );
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.Fields.js